import { Skeleton } from "@mui/material";

export const WizardSkeleton: React.FC = () => {
    return (
        <>
            <Skeleton variant="rectangular" sx={{ height: "5vh" }} />
            <p></p>
            <Skeleton variant="rectangular" sx={{ height: "25vh" }} />
        </>
    );
};
